export default "__VITE_ASSET__DEnMfTd6__"